const commentItems = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20person%2C%20warm%20studio%20lighting%2C%20neutral%20background%2C%20professional%20yet%20friendly%20expression%2C%20clean%20modern%20portrait&width=120&height=120&seq=avatar-01-heiliao&orientation=squarish',
    name: '深度观察者',
    time: '2小时前',
    content: '这个平台的事件梳理真的很全面，不是那种标题党，每次看完都能对事件有完整的了解。特别是时间线的整理方式，一目了然。',
    likes: 326,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Asian%20woman%2C%20warm%20natural%20lighting%2C%20neutral%20soft%20background%2C%20thoughtful%20expression%2C%20editorial%20portrait%20style%2C%20clean%20composition&width=120&height=120&seq=avatar-02-heiliao&orientation=squarish',
    name: '吃瓜群众小李',
    time: '5小时前',
    content: '之前对很多事件都是一知半解，看了黑料入口的解读才知道背后有这么多隐情。理性吃瓜才是正道，推荐给身边的朋友了！',
    likes: 218,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Asian%20man%20with%20glasses%2C%20warm%20studio%20lighting%2C%20neutral%20background%2C%20intellectual%20vibe%2C%20modern%20business%20portrait%20style&width=120&height=120&seq=avatar-03-heiliao&orientation=squarish',
    name: '行业观察笔记',
    time: '8小时前',
    content: '做为从业者，很认可平台的解读深度。特别是企业揭秘板块，很多分析角度都是普通媒体不会涉及的，信息量很大。',
    likes: 187,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            读者热议
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            看看大家对近期热点事件的看法
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {commentItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl border border-background-200/60 p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{item.name}</p>
                  <p className="text-xs text-foreground-500">{item.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                "{item.content}"
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-heart-line text-accent-500"></i>
                <span>{item.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}